import { CustomTestEditContext, useCustomTestEdit } from 'pages/custom_tests_v1/components/custom_test_edit/context';
import { CustomTestSettings } from 'pages/custom_tests_v1/components/CustomTestSettings';
import { useCustomTests } from 'pages/custom_tests_v1/context';
import { useRegisterHeaderControls } from 'components/layout';
import { useIntl } from 'react-intl';

export const SettingsTab = props => {

    const { handleSave, loading, saving } = useCustomTestEdit();
    const { permissions } = useCustomTests();
    const { formatMessage } = useIntl();

    useRegisterHeaderControls(permissions.CanEdit ? {
        cta: {
            disabled: loading || saving,
            label: formatMessage({ id: 'save.d44082ae', defaultMessage: 'Save' }),
            onClick: () => handleSave()
        }
    } : null);

    return (
        <div className={'settings-tab'}>
            <CustomTestSettings context={CustomTestEditContext}/>
        </div>
    );

};
